import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["songTitle"];

  connect() {
    this.element.reset();
    this.onSongChange();
  }

  onSongChange(event) {
    console.log("song change", event)
    var target =
      event?.target || $("[data-action='song-contest-song#onSongChange']");
    $(this.songTitleTarget).val($(target).find("option:selected").text());
  }
}
